import { LocalStorageService } from '@sm360/widget-commons-general';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import * as catalogTypes from 'catalog/actions/catalogActionTypes.js';
import CatalogFilterModel from 'catalog/models/CatalogFilterModel.js';

const { PurchaseMethodsActionsTypes } = PurchaseMethods;

export default function catalogFilterReducer(state = new CatalogFilterModel(), action) {
    switch (action.type) {
        case catalogTypes.LOAD_MAKES_SUCCESS:
            return state.set('makes', action.makes);

        case catalogTypes.SET_FILTER:
            return action.catalogFilter;

        case catalogTypes.FILTER_MAKE:
            return state.set('preferredMake', action.make.value);

        case catalogTypes.FILTER_MODEL:
            return state.set('modelSearchString', action.modelSearchString);

        case PurchaseMethodsActionsTypes.SELECT_PURCHASE_METHOD:
            return state.set('purchaseMethodOrder', action.purchaseMethod.value);

        case PurchaseMethodsActionsTypes.SELECT_PAYMENT_FREQUENCY:
            LocalStorageService.set('paymentFrequency', action.paymentFrequency.value);
            return state.set('paymentFrequency', action.paymentFrequency.value);

        default:
            return state;
    }
}
